// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"Item_itemContainer__3AX25","header":"Item_header__3k9nA","author":"Item_author__2BPFz","bold":"Item_bold__Pc2Nl","icon":"Item_icon__1Qsmy"};